var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "footer", attrs: { id: "contact" } },
    [
      _c("div", { staticClass: "footer__container" }, [
        _c("div", { staticClass: "links" }, [
          _c(
            "div",
            { staticClass: "link__block" },
            [
              _c("h3", [_vm._v(_vm._s(_vm.$t("footer.legal")))]),
              _vm._v(" "),
              _c("router-link", { attrs: { to: "/privacy" } }, [
                _vm._v(_vm._s(_vm.$t("footer.privacy")))
              ]),
              _vm._v(" "),
              _c("router-link", { attrs: { to: "/terms" } }, [
                _vm._v(_vm._s(_vm.$t("footer.terms")))
              ]),
              _vm._v(" "),
              _c("router-link", { attrs: { to: "/policy" } }, [
                _vm._v(_vm._s(_vm.$t("footer.subscription")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "link__block" }, [
            _c("h3", [_vm._v(_vm._s(_vm.$t("footer.getInTouch")))]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "mail",
                attrs: { href: "mailto:" + _vm.supportEmail }
              },
              [_vm._v(_vm._s(_vm.supportEmail))]
            ),
            _vm._v(" "),
            _c(
              "a",
              { staticClass: "mail show-contact-form", attrs: { href: "#" } },
              [_vm._v(_vm._s(_vm.$t("footer.contactUs")))]
            ),
            _vm._v(" "),
            _c(
              "a",
              { staticClass: "mail cancel-subscription", attrs: { href: "#" } },
              [_vm._v(_vm._s(_vm.$t("footer.cancelSubscription.title")))]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "company_block" }, [
          _c("div", { staticClass: "company_logo" }, [
            _c("img", {
              attrs: { src: _vm.mediaBaseUrl + "logo-white.svg", alt: "" }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "company_name" }, [
              _vm._v(
                "\n          1D3 DIGITECH OÜ is an authorized global distributor of\n          dynamic-fitness-pro.com\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "copyright" }, [
            _vm._v("Copyright © Cros - Corp Investments Ltd")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("cancel-subscription")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }